import { createAction, props } from '@ngrx/store';
import {
  Account,
  AccountCountry,
  AccountReviewer,
} from 'graphql-api/gql-api-interfaces';

export const loadAccounts = createAction('[Accounts] Load Accounts');

export const loadAccountsSuccess = createAction(
  '[Accounts] Load Accounts Success',
  props<{ list: Account[]; total: number; pageSize?: number | null }>(),
);

export const loadAccountsFailure = createAction(
  '[Accounts] Load Accounts Failure',
  props<{ error: string }>(),
);

export const setSearchQuery = createAction(
  '[Accounts] Set Search Query',
  props<{ query: string }>(),
);

export const resetAccountsSearchHistory = createAction(
  '[Accounts] Reset Accounts Search History',
  props<{ skipIds: string[] }>(),
);

export const setPaginationQuery = createAction(
  '[Accounts] Set Pagination Query',
);

export const resetPaginationQuery = createAction(
  '[Accounts] Reset Pagination Query',
);

export const setAccountBESearchEnabled = createAction(
  '[Accounts] Set Accounts BE Search Enabled',
  props<{ isBESearchEnabled: boolean }>(),
);

export const confirmActiveAccountSelection = createAction(
  '[Accounts] Confirm Active Account Selection',
  props<{ activeAccount: Account }>(),
);

export const setActiveAccount = createAction(
  '[Accounts] Set active account',
  props<{ account: Account; isDetailedAccount?: boolean }>(),
);

export const clearActiveAccount = createAction(
  '[Accounts] Clear active account',
);

export const resolveActiveAccount = createAction(
  '[Accounts] Resolve Active Account',
  props<{ accountId: string }>(),
);

export const upsertAccounts = createAction(
  '[Accounts] Upsert entity with accounts',
  props<{ accounts: Account[] }>(),
);

export const loadAccountDetailsSuccess = createAction(
  '[Accounts] Load Account Details Success',
  props<{ account: Account }>(),
);

export const loadAccountDetailsFailure = createAction(
  '[Accounts] Load Account Details Failure',
  props<{ error: string }>(),
);

export const loadAccountCountries = createAction(
  '[Accounts] Load Account Countries',
);
export const loadAccountCountriesSuccess = createAction(
  '[Accounts] Load Account Countries Success',
  props<{ countries: AccountCountry[] }>(),
);
export const loadAccountCountriesFailure = createAction(
  '[Accounts] Load Account Countries Failure',
  props<{ message: string }>(),
);

export const loadAccountReviewers = createAction(
  '[Accounts] Load Account Reviewers',
  props<{ basketId: string }>(),
);
export const loadAccountReviewersSuccess = createAction(
  '[Accounts] Load Account Reviewers Success',
  props<{ reviewers: AccountReviewer[] }>(),
);
export const loadAccountReviewersFailure = createAction(
  '[Accounts] Load Account Reviewers Failure',
  props<{ message: string }>(),
);

export const setReviewerSearchQuery = createAction(
  '[Basket Reviewer] Set search query',
  props<{ query: string }>(),
);
